import { isBoolean, isDate, isNumber, isRegExp, isString, isSymbol } from 'lodash';

export const isPrimitive = (value: any) =>
  isString(value) || isNumber(value) || isDate(value) || isBoolean(value) || isSymbol(value) || isRegExp(value);
